<script>
  import * as R from 'ramda';
  import { INSPECTION_RESPONSE_SET_TYPE } from '@/_legacy/constants';
  import ConductInspectionItemQuestionListResponse
    from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionListResponse.vue';
  import DropdownModal from '@/_legacy/views/ConductInspection/Modals/DropdownModal.vue';
  import authMixin from '@/_legacy/mixins/authMixin';
  import {
    QuestionOptions
  } from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/QuestionOptions';
  import { useBuilderMode } from '@/ui/concerns/checklist/useBuilderMode';

  const handleResponseClicked = (value, item) => {
    const { response } = item;
    if (!response) {
      return [value];
    }

    if (response.includes(value)) {
      return response.filter(uuid => uuid !== value);
    }

    const isMultiselect = R.path(['params', 'multiple_selection'], item);
    return isMultiselect ? [...response, value] : [value];
  };

  export default {
    name: 'ConductInspectionItemQuestionList',
    components: {
      ConductInspectionItemQuestionListResponse,
      DropdownModal,
      QuestionOptions
    },
    mixins: [authMixin],

    props: {
      item: {
        type: Object,
        required: true,
      },
      entities: {
        type: Object,
        required: true,
      },
      previewMode: {
        type: [Boolean, String],
        default: false,
      },
    },
    setup() {
      const { isTranslationMode } = useBuilderMode();

      return { isTranslationMode };
    },
    data: () => ({
      isDropdownVisible: false,
      isRaiseIssueModalVisible: false,
    }),
    computed: {
      responseSet() {
        return (
          this.entities.response_sets[this.item.params.response_set] || []
        );
      },
      selectedTitles() {
        if (!this.item.responded || !this.item.response) {
          return [];
        }

        return this.responseSet.responses
          .filter(({ uuid }) => this.item.response.includes(uuid))
          .map(({ title }) => title);
      },
      isDropdown() {
        return (
          this.responseSet.type === INSPECTION_RESPONSE_SET_TYPE.DROPDOWN
        );
      },
      dropdownTitle() {
        return this.selectedTitles.length
          ? this.selectedTitles.join(', ')
          : this.$t('Select from dropdown');
      },
      hasLongOption() {
        return this.previewMode && this.responseSet.type === 'list' && this.responseSet.responses.some(item => item.title.length > 20);
      }
    },
    methods: {
      responseClicked(value) {
        const response = handleResponseClicked(value, this.item);
        return this.$emit('change', {
          uuid: this.item.uuid,
          response,
          responded: !!(response && response.length),
        });
      },
      dropdownClicked(response) {
        this.$emit('change', {
          uuid: this.item.uuid,
          response,
          responded: !!(response && response.length),
        });
        this.closeDropdown();

        return response;
      },
      closeDropdown() {
        this.isDropdownVisible = false;
      },
    },
  };
</script>

<template>
  <div>
    <div
      v-if="isDropdown"
      class="w-full form-select"
      :class="{ empty: !selectedTitles }"
      @click="isDropdownVisible = true"
    >
      <span>{{ dropdownTitle }}</span>
    </div>
    <div v-else class="preview__question-list" :class="{
            'preview__question-list--block': previewMode && previewMode !== 'tablet'
        }"
    >
      <ConductInspectionItemQuestionListResponse
        v-for="response in responseSet.responses"
        :key="response.uuid"
        :response="response"
        :selected="!!(item.response && item.response.includes(response.uuid))"
        :has-long-option="hasLongOption"
        @click="responseClicked"
      />
    </div>

    <QuestionOptions :item="item" :entities="entities" v-on="$listeners" />

    <portal to="modals">
      <transition name="fade">
        <DropdownModal
          v-if="isDropdownVisible"
          :key="item.uuid"
          :responses="responseSet.responses"
          :response="item.response"
          :multiple="item.params.multiple_selection"
          :is-translation-mode="isTranslationMode"
          @save="dropdownClicked"
          @close="closeDropdown"
        />
      </transition>
    </portal>
  </div>
</template>

<style scoped>
.preview__question-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(5rem, 1fr));
  gap: 0.5rem;
  justify-content: start;
}

.preview__question-list--block {
  @apply flex flex-col;
  gap: 0;
}

.preview__question-list > button {
  @apply p-6 flex flex-col items-center justify-center whitespace-normal;
}

.preview__question-list > button:not(:first-child) {
  @apply mt-0;
}

.preview__question-list--block > button {
  @apply py-0;
}

.preview__question-list--block > button:not(:first-child) {
  margin-top: 0.5rem;
}

.preview__question-list--block > .ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: start;
}
</style>
